import { render } from "./UploadTransactionReceipt.vue?vue&type=template&id=52b43d5a&scoped=true&ts=true"
import script from "./UploadTransactionReceipt.vue?vue&type=script&lang=ts"
export * from "./UploadTransactionReceipt.vue?vue&type=script&lang=ts"

import "./UploadTransactionReceipt.vue?vue&type=style&index=0&id=52b43d5a&scoped=true&lang=css"
import "./UploadTransactionReceipt.vue?vue&type=style&index=1&id=52b43d5a&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b43d5a"]])

export default __exports__